import React, { useState } from 'react'
import Text from '../../text/Text'
import SvgIcon from '../../svgIcon/SvgIcon'
import { UpsellingPendingStyles } from './pendingStyle'
import useMediaQueries from '../../../hooks/useMediaQuery'
import './pending.css'

type DataListItem = string | string[]

export interface UpsellingPendingProperties {
    headtitle: string
    title: string
    text: string
    btn1?: { title: string; action: () => void }
    btn2?: { title: string; action: () => void }
    list: DataListItem[]
    image: any
    optionsText?: string
    contract?: string
    endText?: string
    version?: 1 | 2
}

export function UpsellingPending(properties: UpsellingPendingProperties) {
    const matches = useMediaQueries({
        isTabletOrMobile: '(max-width: 1220px)',
    })

    const [showAlert, setShowAlert] = useState(true)

    if (properties.version == 2) {
        return (
            <div
                style={{
                    backgroundColor: '#fff',
                    borderRadius: 16,
                    padding: 40,
                }}
            >
                {showAlert && properties.contract && (
                    <div style={UpsellingPendingStyles.alertContainer}>
                        <div style={UpsellingPendingStyles.alertIcon}>
                            <SvgIcon
                                width={25}
                                height={25}
                                iconName="IconWarningWhite"
                            />
                        </div>

                        <div style={UpsellingPendingStyles.alertTextContainer}>
                            <div
                                style={UpsellingPendingStyles.alertTextContent}
                            >
                                <Text
                                    label="Activa esta opción"
                                    fontWeight={700}
                                    color="#184287"
                                    marginRight={5}
                                    fontSize={14}
                                />
                                <Text
                                    label={properties.contract}
                                    fontWeight={400}
                                    color="#184287"
                                    fontSize={14}
                                />
                            </div>
                            <button
                                onClick={() => setShowAlert(false)}
                                style={
                                    UpsellingPendingStyles.alertActionContent
                                }
                            >
                                <SvgIcon
                                    iconName="IconX"
                                    width={20}
                                    height={20}
                                />
                            </button>
                        </div>
                    </div>
                )}
                <div
                    style={{
                        ...UpsellingPendingStyles.content,
                        flexWrap: matches.isTabletOrMobile ? 'wrap' : 'nowrap',
                    }}
                >
                    <div style={UpsellingPendingStyles.contentLeft}>
                        <div style={UpsellingPendingStyles.contentIconv2}>
                            <SvgIcon iconName="StackedBarChart" />
                            <Text
                                label={properties.headtitle}
                                fontFamily="Montserrat"
                                fontWeight={600}
                                color="#0086D6"
                                fontSize={20}
                            />
                        </div>
                        <Text
                            label={properties.title}
                            fontFamily="Montserrat"
                            marginBottom={10}
                            fontWeight={600}
                            color="#184287"
                            fontSize={36}
                        />
                        <Text
                            label={properties.text}
                            fontFamily="Montserrat"
                            marginBottom={25}
                            fontWeight={400}
                            color="#464646"
                            fontSize={20}
                        />
                        <div style={UpsellingPendingStyles.actionsContainer}>
                            {properties.btn1 && (
                                <button
                                    onClick={properties.btn1.action}
                                    style={UpsellingPendingStyles.btn1}
                                >
                                    <Text
                                        color="#FFF"
                                        fontSize={14}
                                        fontWeight={600}
                                        label={properties.btn1.title}
                                    />
                                </button>
                            )}
                            {properties.btn2 && (
                                <button
                                    onClick={properties.btn2.action}
                                    style={UpsellingPendingStyles.btn2}
                                >
                                    <Text
                                        fontSize={14}
                                        color="#74BE00"
                                        fontWeight={600}
                                        label={properties.btn2.title}
                                    />
                                </button>
                            )}
                        </div>
                        {properties.optionsText && (
                            <Text
                                label={properties.optionsText}
                                fontFamily="Montserrat"
                                marginBottom={25}
                                fontWeight={400}
                                color="#464646"
                                fontSize={20}
                            />
                        )}
                    </div>
                    <div
                        style={{
                            flex: 1,
                            display: 'flex',
                            alignItems: 'flex-start',
                            justifyContent: 'center',
                        }}
                    >
                        <img
                            alt="imagen"
                            src={properties.image}
                            className="upselling-img-logo"
                        />
                    </div>
                </div>
                <div style={{ marginTop: 20 }}>
                    <div style={UpsellingPendingStyles.contentCheckv2}>
                        {properties.list.map((item, index) =>
                            Array.isArray(item) ? (
                                <div key={index}>
                                    {item.map((subItem, subIndex) => (
                                        <div
                                            key={subIndex}
                                            style={
                                                UpsellingPendingStyles.checkItem
                                            }
                                        >
                                            <SvgIcon
                                                iconName="IconCheckGreen"
                                                width={19}
                                                height={20}
                                            />
                                            <Text
                                                fontFamily="Montserrat"
                                                fontWeight={400}
                                                marginLeft={10}
                                                color="#464646"
                                                fontSize={20}
                                                label={subItem}
                                            />
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div
                                    key={index}
                                    style={UpsellingPendingStyles.checkItem}
                                >
                                    <SvgIcon
                                        iconName="IconCheckGreen"
                                        width={19}
                                        height={20}
                                    />
                                    <Text
                                        fontFamily="Montserrat"
                                        fontWeight={400}
                                        marginLeft={10}
                                        color="#464646"
                                        fontSize={20}
                                        label={item}
                                    />
                                </div>
                            )
                        )}
                    </div>
                </div>
                {properties.endText && (
                    <div style={{ width: '80%' }}>
                        <Text
                            label={properties.endText}
                            fontFamily="Montserrat"
                            fontWeight={600}
                            marginTop={20}
                            fontSize={16}
                            color="#000"
                        />
                    </div>
                )}
            </div>
        )
    }

    return (
        <>
            {showAlert && (
                <div style={UpsellingPendingStyles.alertContainer}>
                    <div style={UpsellingPendingStyles.alertIcon}>
                        <SvgIcon
                            width={25}
                            height={25}
                            iconName="IconWarningWhite"
                        />
                    </div>
                    <div style={UpsellingPendingStyles.alertTextContainer}>
                        <div style={UpsellingPendingStyles.alertTextContent}>
                            <Text
                                label="Activa esta opción"
                                fontWeight={700}
                                color="#184287"
                                marginRight={5}
                                fontSize={14}
                            />
                            <Text
                                label={properties.contract}
                                fontWeight={400}
                                color="#184287"
                                fontSize={14}
                            />
                        </div>
                        <button
                            onClick={() => setShowAlert(false)}
                            style={UpsellingPendingStyles.alertActionContent}
                        >
                            <SvgIcon iconName="IconX" width={20} height={20} />
                        </button>
                    </div>
                </div>
            )}
            <div
                style={{
                    ...UpsellingPendingStyles.content,
                    flexWrap: matches.isTabletOrMobile ? 'wrap' : 'nowrap',
                }}
            >
                <div style={UpsellingPendingStyles.contentLeft}>
                    <div style={UpsellingPendingStyles.contentIcon}>
                        <SvgIcon iconName="IconLockedColor" />
                        <Text
                            label={properties.headtitle}
                            fontWeight={600}
                            color="#0086D6"
                            fontSize={20}
                        />
                    </div>
                    <Text
                        label={properties.title}
                        marginBottom={10}
                        fontWeight={700}
                        color="#0086D6"
                        fontSize={41}
                    />
                    <Text
                        label={properties.text}
                        color="#5154588C"
                        marginBottom={25}
                        fontWeight={400}
                        fontSize={21}
                        variant="upselling-text-"
                    />
                    <div style={UpsellingPendingStyles.actionsContainer}>
                        {properties.btn1 && (
                            <button
                                onClick={properties.btn1.action}
                                style={UpsellingPendingStyles.btn1}
                            >
                                <Text
                                    color="#FFF"
                                    fontSize={14}
                                    fontWeight={600}
                                    label={properties.btn1.title}
                                />
                            </button>
                        )}
                        {properties.btn2 && (
                            <button
                                onClick={properties.btn2.action}
                                style={UpsellingPendingStyles.btn2}
                            >
                                <Text
                                    fontSize={14}
                                    color="#74BE00"
                                    fontWeight={600}
                                    label={properties.btn2.title}
                                />
                            </button>
                        )}
                    </div>
                    <div style={UpsellingPendingStyles.contentCheck}>
                        {properties.list.map((item, index) =>
                            Array.isArray(item) ? (
                                <></>
                            ) : (
                                <div
                                    key={index}
                                    style={UpsellingPendingStyles.checkItem}
                                >
                                    <SvgIcon
                                        iconName="IconCheckGreen"
                                        width={19}
                                        height={20}
                                    />
                                    <Text
                                        fontWeight={400}
                                        marginLeft={10}
                                        color="#184287"
                                        fontSize={12}
                                        label={item}
                                    />
                                </div>
                            )
                        )}
                    </div>
                </div>
                <div
                    style={{
                        flex: 1,
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'center',
                    }}
                >
                    <img
                        alt="imagen"
                        src={properties.image}
                        className="upselling-img-logo"
                    />
                </div>
            </div>
        </>
    )
}
